import { useResponsive } from '@actual-app/components/hooks/useResponsive';

import { Modal } from '#components/common/Modal';
import { color } from '#components/mobile/ui/tokens';
import { PantallaTripulacion } from '#components/pareja/PantallaTripulacion';
import type { Modal as ModalType } from '#modals/modalsSlice';

type CompartirPresupuestoModalProps = Extract<
  ModalType,
  { name: 'compartir-presupuesto' }
>['options'];

/**
 * La «Tripulación» de un barco: se abre desde el puerto («Compartir»), desde
 * Ajustes y desde la tarjeta «A bordo» de Inicio. En el móvil ocupa la
 * pantalla entera; las hojas de dentro (confirmar «Bajar del barco») salen
 * encima con la pantalla atenuada.
 */
export function CompartirPresupuestoModal({
  fileId,
  nombre,
}: CompartirPresupuestoModalProps) {
  const { isNarrowWidth } = useResponsive();
  return (
    <Modal
      name="compartir-presupuesto"
      wrapperProps={{
        style: {
          height: '100dvh',
          alignItems: isNarrowWidth ? 'stretch' : undefined,
        },
      }}
      containerProps={{
        style: {
          padding: 0,
          overflow: 'hidden',
          backgroundColor: color.bg,
          ...(isNarrowWidth ? estiloMovil : estiloPC),
        },
      }}
    >
      {({ state }) => (
        <PantallaTripulacion
          fileId={fileId}
          nombre={nombre}
          onCerrar={() => state.close()}
        />
      )}
    </Modal>
  );
}

// Alto visible real del móvil (con o sin barra del navegador).
const estiloMovil = {
  minWidth: '100vw',
  maxWidth: '100vw',
  height: '100dvh',
  maxHeight: '100dvh',
  borderRadius: 0,
} as const;

const estiloPC = {
  minWidth: 430,
  maxWidth: 430,
  height: 'min(860px, 90dvh)',
} as const;
